/* MUI */
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Components */
import { KPICard } from '../../internal/KPICard';

export const SummaryCard = ({
    totalNumberOfContracts,
    totalContractValue,
    totalMonthlyValue
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box
            data-testid="contractsReportSummaryCard"
            data-trackid="contractsReportSummaryCard"
            sx={{
                backgroundColor: 'background.reportSummaryCardLight',
                flexFlow: 'wrap'
            }}
            display="flex"
            width="100%"
        >
            <Box flex={1} m="24px">
                <KPICard
                    backgroundColor={
                        theme?.palette.background.reportSummaryCardDark
                    }
                    bigNumber
                    number={totalNumberOfContracts}
                    textColor={theme?.palette.text.reportSummaryCardLight}
                    title={t('Reports.Contracts.totalContracts')}
                />
            </Box>
            <Box flex={2} display="flex" m="24px">
                <Box flex={1}>
                    <KPICard
                        backgroundColor={
                            theme?.palette.background.reportSummaryCardLight
                        }
                        number={totalContractValue}
                        title={t('Reports.Contracts.totalContractValue')}
                        numberIsCurrency
                        textColor={theme?.palette.text.reportSummaryCardDark}
                    />
                </Box>
                <Box flex={1}>
                    <KPICard
                        backgroundColor={
                            theme?.palette.background.reportSummaryCardLight
                        }
                        number={totalMonthlyValue}
                        title={t('Reports.Contracts.totalMonthlyValue')}
                        numberIsCurrency
                        textColor={theme?.palette.text.reportSummaryCardDark}
                    />
                </Box>
            </Box>
        </Box>
    );
};
